import { useRef, useState } from "react";

export const useConversationSearch = () => {
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  const searchDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleSearch = () => {
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
      searchDebounceRef.current = null;
    }
    setDebouncedSearchValue(searchValue);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);

    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    searchDebounceRef.current = setTimeout(() => {
      setDebouncedSearchValue(value);
      searchDebounceRef.current = null;
    }, 500);
  };

  return {
    searchValue,
    setSearchValue,
    debouncedSearchValue,
    setDebouncedSearchValue,
    handleSearch,
    handleChange,
    searchDebounceRef,
  };
};
